<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    밍글 내역
                </div>
                <div class="list-content">
                    <point-list-component :pointType="`pointAllHistory`"></point-list-component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PointListComponent from "@/components/point/PointListComponent";

export default {
    name: "MingleHistory",
    mixins: [],
    components: {PointListComponent},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {}
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        movePage(url) {
            this.$router.push(url)
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
